import { ERROR } from "../actionTypes";

export const GET_GROW_NETWORK_STATS = "GET_GROW_NETWORK_STATS";
export const GET_GROW_NETWORK_CONTACTS = "GET_GROW_NETWORK_CONTACTS";
export const SET_GROW_NETWORK_LOADING = "SET_GROW_NETWORK_LOADING";
export const CLEAR_GROW_NETWORK_CONTACTS = "CLEAR_GROW_NETWORK_CONTACTS";

export { ERROR };
